import { useEffect } from 'react';
import { useFormikContext } from 'formik';

import type { Id } from '@e-socna/data-layer';

import type { MissionDocumentTemplate } from '../types/mission-document-template.type';

// The template of the mission type is set once, while no template is chosen yet (an emptied field
// stays empty).
export const useDefaultTemplateId = ({
  defaultTemplateId,
  templates,
}: Readonly<{
  defaultTemplateId: Id | undefined;
  templates: readonly MissionDocumentTemplate[];
}>) => {
  const { setFieldValue, values } =
    useFormikContext<Readonly<{ templateId?: Id | string }>>();
  const isAvailable =
    !!defaultTemplateId &&
    templates.some(({ _id }) => _id === defaultTemplateId);

  useEffect(() => {
    if (values.templateId === undefined && isAvailable) {
      void setFieldValue('templateId', defaultTemplateId);
    }
  }, [defaultTemplateId, isAvailable, setFieldValue, values.templateId]);
};
